import {OptimizerStockLevelMaterialDetailChart} from './detail/OptimizerStockLevelMaterialDetailChart'
import {useSelectedMaterialId} from './SelectedMaterialIdProvider'
import {OptimizerStockLevelsSummary} from './summary/OptimizerStockLevelsSummary'

export const OptimizerStockLevelsCardContent = ({plantCode}: {plantCode: string}) => {
  const {materialId} = useSelectedMaterialId()

  return materialId !== undefined ? (
    <OptimizerStockLevelMaterialDetailChart plantCode={plantCode} />
  ) : (
    <OptimizerStockLevelsSummary />
  )
}
